// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

export const getAllDataClientsOptions = createAsyncThunk('appUsers/getAllDataClientsOptions', async () => {
  const response = await axios.get('https://apiv4dev2.opentlv.com/api/v3/clients/options/all')
  return response.data
})

export const getDataClientsOptions = createAsyncThunk('appUsers/getDataClientsOptions', async params => {
  const response = await axios.get('https://apiv4dev2.opentlv.com/api/v3/clients/options/data', {params})
  return {
    params,
    data: response.data.data,
    totalPages: response.data.total
  }
})

export const getUser = createAsyncThunk('appUsers/getUser', async id => {
  const response = await axios.get('https://apiv4dev2.opentlv.com/api/v3/users/user', { params: { id} })
  console.log(response.data)
  return response.data
})

export const addUser = createAsyncThunk('appUsers/addUser', async (user, { dispatch, getState }) => {
  await axios.post('/apps/users/add-user', user)
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return user
})

export const deleteUser = createAsyncThunk('appUsers/deleteUser', async (id, { dispatch, getState }) => {
  await axios.delete('/apps/users/delete', { id })
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return id
})

export const addOption = createAsyncThunk('appUsers/addOption', async (option, { dispatch, getState }) => {
 

  await axios.post('https://apiv4dev2.opentlv.com/api/v3/clients/addoption', option)

  //await dispatch(getAllDataSitesClient(getState().sitesClient.params.id))
  await dispatch(getDataClientsOptions(getState().options.params))
  return site
})

export const deleteOption = createAsyncThunk('appUsers/deleteOption', async (id, { dispatch, getState }) => {
  console.log("getState()")
  console.log(id)

  await axios.delete('https://apiv4dev2.opentlv.com/api/v3/clients/option/delete', {params: {id}})
//  await dispatch(getData(getState().users.params))
    await dispatch(getDataClientsOptions(getState().options.params))

  return id
})
export const appClientsSlice = createSlice({
  name: 'appUsers',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedOption: null
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAllDataClientsOptions.fulfilled, (state, action) => {
        state.allData = action.payload
       // state.selectedOption = action.payload.option  
      })
      .addCase(getDataClientsOptions.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.selectedUser = action.payload
      })
  }
})

export default appClientsSlice.reducer
